import {RemoteValue} from "../../../util/RemoteValue";
import {GoToCategory, GoToItem} from "../GoToItem";
import {useMemo} from "react";
import Permission from "../../../util/access/Permission";
import {usePermission} from "../../../util/access/UseAccess";

export function useGoToItems<R>(
    categoryName: string,
    requiredPermissions: readonly Permission[],
    sourceValue: RemoteValue<R>,
    items: (sourceValue: R) => GoToItem[]
): RemoteValue<GoToCategory> {
    const {canShowItems} = usePermission({canShowItems: requiredPermissions});

    return useMemo(
        () => canShowItems
            ? sourceValue.map(value => ({
                name: categoryName,
                items: items(value),
            }))
            : RemoteValue.fromValue({
                name: categoryName,
                items: [],
            }),
        [canShowItems, categoryName, sourceValue, items],
    );
}
